// Copyright © 2021 Move Closer
export var AuthorCardSelectionOption;
(function (AuthorCardSelectionOption) {
    AuthorCardSelectionOption["Default"] = "default";
    AuthorCardSelectionOption["Smart"] = "smart";
})(AuthorCardSelectionOption || (AuthorCardSelectionOption = {}));
